import React, {ReactNode, useRef, useState} from "react";
import styles from './WaitLoader.module.css'
import loader from '../Img/loader.gif'
import useApiQuery, {ApiQueryResponse} from "../ApiQuery/UseApiQuery";
import ModalWindow from "../FormTemplate/ModalWindow/ModalWindow";
import {useNavigate} from "react-router-dom";

interface WaitLoaderInt
{
    children: ReactNode| undefined
    loading: boolean;
    api?: ApiQueryResponse
    onlyLoading:boolean
    showError?:boolean
}

export default function WaitLoader({children,loading,api,onlyLoading,showError}:WaitLoaderInt)
{
    const [ldrDummy,rsDummy,exClientUpdate] = useApiQuery("/dummy","post",useRef(null));
    const [xApi,setXApi] = useState(api ? api : rsDummy)
    const navigate = useNavigate()

    if(loading) return(
        <div className={styles.container}>
            <img className={styles.image} src={loader} alt={"wait"}></img>
        </div>
    );


    if(! xApi.success && !loading && xApi.code!==-200 && !onlyLoading)
        return(
            <ModalWindow onClose={()=>{navigate('/')}}>
                <div className={styles.modal}>
                    <div className={styles.modalHeader}>
                        <h5 className={styles.heading}>Ошибка</h5>
                    </div>
                    <div className={styles.modalContent}>
                        {xApi.errorAsString}
                    </div>
                </div>
            </ModalWindow>
        )
    if(showError && !xApi.success && xApi.code!==-200)
        return (
            <h3>{xApi.errorAsString}</h3>
        )


    return (
        <>
            {children}
        </>
    )
}